module.exports = __webpack_public_path__ + "img/section-meter-heat-meter-counter-sm.aab5f2bd.svg";